export default __webpack_public_path__ + "static/media/noimage.2a943df8.jpg";